export default __webpack_public_path__ + "0fcd45fbfc419c42c8b96fafe87db102.ttf";